export const TIMETRACKING_FEATURES = {
  moduleKey: 'timetracking',
  features: [
    'timetracking.clock-in',
    'timetracking.clock-out',
    'timetracking.reports',
    'timetracking.balances',
    'timetracking.settings',
  ] as const,
  featureMeta: {
    'timetracking.clock-in': {
      name: 'Clock in',
      translations: { name: { de: 'Einstempeln', en: 'Clock in', fr: 'Pointer', it: 'Registrazione ingresso' } },
    },
    'timetracking.clock-out': {
      name: 'Clock out',
      translations: { name: { de: 'Ausstempeln', en: 'Clock out', fr: 'Pointer la sortie', it: 'Registrazione uscita' } },
    },
    'timetracking.reports': {
      name: 'Time tracking reports',
      translations: {
        name: {
          de: 'Zeiterfassungsberichte',
          en: 'Time tracking reports',
          fr: 'Rapports de suivi du temps',
          it: 'Report del rilevamento del tempo',
        },
      },
    },
    'timetracking.balances': {
      name: 'Time balances',
      translations: { name: { de: 'Zeitguthaben', en: 'Time balances', fr: 'Soldes horaires', it: 'Saldi orari' } },
    },
    'timetracking.settings': {
      name: 'Time tracking settings',
      translations: {
        name: {
          de: 'Zeiterfassungseinstellungen',
          en: 'Time tracking settings',
          fr: 'Paramètres du suivi du temps',
          it: 'Impostazioni del rilevamento del tempo',
        },
      },
    },
  },
} as const;
